// extracted by mini-css-extract-plugin
export var container = "_sq-0";
export var dotAnimation = "_sq-2";
export var dotsLoading = "_sq-1";